import TIM from 'tim-js-sdk/tim-js-friendship.js'
import TIMUploadPlugin from 'tim-upload-plugin'
import TRTCCalling from 'trtc-calling-js'
// import { TUICallEngine } from 'tuicall-engine-webrtc'
import Vue from 'vue'
import store from '../store'
import config from '@/config/index'
import {
    getUserSig
} from '@/api/live'

let tim = null
let trtcCalling

const getUserInfo = () => {
    // 获取本地用户登录信息
    console.log('store.getters.info--->', store.getters.info)
    const timUserInfo = store.getters.info ? store.getters.info.userInfo : {
        name: '',
        headImage: ''
    }
    // 昵称|姓名
    const name = timUserInfo.name || '匿名用户'
    // 头像
    const headImg = timUserInfo.headImage

    return {
        name,
        headImg
    }
}

//  存储弹幕信息
const receivedMsg = function (ev) {
    store.commit('SET_DAN_MU_DATA', ev.data)
}

// 设置头像、昵称
const sdkReady = function () {
    const { name, headImg } = getUserInfo()
    tim.updateMyProfile({
        nick: name || '',
        avatar: headImg || ''
    }).then(function (imResponse) {
        console.log(imResponse.data)
        console.log('更新资料成功')
    }).catch((err) => {
        console.log('更新失败。。。', err)
    })
}

//TIM 初始化
const timInit = function() {
    // 实例化 tim
    tim = TIM.create({
        /**
         * SDKAppID
         * 正式:1400363234
         * 测试:1400365313
         * 测试1:1400801492
         */
        // TODO 要修改
        SDKAppID: config.SDKAppID,
        // 如果您的应用需要在海外使用，请设置为 true，SDK 将替换域名，避免在某些国家或地区被干扰
        oversea: true
    })

    trtcCalling = new TRTCCalling({
        // trtcCalling = TUICallEngine.createInstance({
        SDKAppID: config.SDKAppID,
        tim
    })

    // 注册上传插件
    tim.registerPlugin({ 'tim-upload-plugin': TIMUploadPlugin })

    /**
     * 设置 SDK 日志输出级别，详细分级请参见 setLogLevel 接口的说明
     * 0 普通级别，日志量较多，接入时建议使用
     * 1 release级别，SDK 输出关键信息，生产环境时建议使用
     * 2 告警级别，SDK 只输出告警和错误级别的日志
     * 3 错误级别，SDK 只输出错误级别的日志
     * 4 无日志级别，SDK 将不打印任何日志
     */
    tim.setLogLevel(1)
    trtcCalling.setLogLevel(2)

    // 监听IM接收信息
    tim.on(TIM.EVENT.MESSAGE_RECEIVED, receivedMsg)

    /**
     * 在登录之前，需要先订阅（监听）TIM.EVENT.SDK_READY事件
     * 登录后，收到会话列表以及未读消息同步完毕通知后，此时才会发布SDK_READY事件，触发sdk is ready通知；
     * 收到sdk is ready的通知，可以开始收发消息。
     */
    tim.on(TIM.EVENT.SDK_READY, sdkReady)
}

timInit()

// TIM 登录
const timLogin = async function (param) {
    console.log('TIM 登录---->', param)
    // 获取 sig 登录用
    const sig = await getUserSig().then(res => {
        console.log(res.data)
        return res.data
    })
    console.log('TIM 登录--->', param)
    const loginStatus = await tim.login({
        userID: param.userID,
        userSig: sig
    }).then(() => {
        return true
    }).catch((err) => {
        console.log('TIM 登录失败', err)
        return false
    })
    return loginStatus
}

// TIM 登出
const timLogout = function () {
    if (tim) {
        tim.off(TIM.EVENT.MESSAGE_RECEIVED, receivedMsg)
        tim.off(TIM.EVENT.SDK_READY, sdkReady)
        tim.logout().then(() => {
            console.log('登出成功')
        }).catch((e) => {
            console.log('登出失败', e)
        })
    }
}

const TimLogOut = function () {
    tim.logout().then(() => {
        store.commit('toggleIsLogin')
        store.commit('reset')
    })
}

/**
 * 腾讯IM登录且加入群
 * @param {Objec} param 
 * {
 *     userID:用户id,
 *     nick:用户名,
 *     avatar:头像,
 *     groupID:群组ID
 * }
 */
const timLoginAddGrounp = async function (param) {
    //加群状态
    let addGroupStatus
    //登录TIM 状态
    // let loginStatus = await timLogin(param)
    // if (!loginStatus) {
    //     return {
    //         msg: '登录失败',
    //         tim: tim
    //     }
    // }
    await tim.joinGroup({
        groupID: param.groupID,
        type: TIM.TYPES.GRP_AVCHATROOM
    }).then(res => {
        switch (res.data.status) {
            case TIM.TYPES.JOIN_STATUS_WAIT_APPROVAL: //等待同意
                addGroupStatus = false
                console.log('等待同意。。。。。群组')
                break;
            case TIM.TYPES.JOIN_STATUS_SUCCESS: // 加群成功
                addGroupStatus = true
                console.log('加群成功。。。。。群组')
                break;
            case TIM.TYPES.JOIN_STATUS_ALREADY_IN_GROUP: // 已经在群中
                addGroupStatus = true
                console.log('已在群中。。。。。群组')
                break;
        }
    }).catch(() => {
        addGroupStatus = false
        return [false, false]
    })
    return {
        addGroupStatus: addGroupStatus,
        tim: tim
    }
}

/**
 * 退出直播群
 */
const timQuitGroup = function(param) {
    if (tim) {
        const promise = tim.quitGroup(param.groupID)
        promise.then(function(imResponse) {
            console.log(imResponse.data.groupID) // 退出成功的群 ID
            return true
        }).catch(function(imError) {
            console.warn('quitGroup error:', imError) // 退出群组失败的相关信息
            return false
        })
        
        // return sendImMessage(param.text, param.groupID, '3').then(() => {
        //     timLogout()
        //     return true
        // }).catch((err) => {
        //     timLogout()
        //     console.log('退出群组失败:', err)
        // })
    }
    return null
}

/**
 * 发送消息
 * @param {String} mess 
 * @param {String} gId 
 * @param {String} type 
 */
const sendImMessage = async function (mess = '', gId, type = '2') {
    const { name, headImg } = getUserInfo()

    const d = {
        cmd: 'CustomCmdMsg',
        data: {
            cmd: type,
            msg: mess,
            userName: name,
            userAvatar: headImg
        }
    }
    // 创建发送消息
    const message = await tim.createCustomMessage({
        to: gId,
        conversationType: TIM.TYPES.CONV_GROUP,
        payload: {
            data: JSON.stringify(d),
            description: '',
            extension: ''
        }
    })
    // 发送消息
    const promise = await tim.sendMessage(message, {
        offlinePushInfo: {
            disablePush: true // 如果接收方不在线，则消息将存入漫游，但不进行离线推送
        }
    })
    return promise
}

export {
    getUserInfo,
    receivedMsg,
    sdkReady,
    timInit,
    timLogout,
    timLogin,
    TimLogOut,
    timLoginAddGrounp,
    timQuitGroup,
    sendImMessage
}

window.$TIM = Vue.prototype.$TIM = tim
window.$TIM_EVENT = Vue.prototype.$TIM_EVENT = TIM.EVENT
window.$TIM_TYPES = Vue.prototype.$TIM_TYPES = TIM.TYPES
window.trtcCalling = Vue.prototype.trtcCalling = trtcCalling
window.TRTCCalling = Vue.prototype.TRTCCalling = TRTCCalling
// window.TRTCCalling = app.TRTCCalling = Vue.prototype.TRTCCalling = TUICallEngine

Vue.prototype.timInit = timInit
Vue.prototype.timLoginAddGrounp = timLoginAddGrounp
Vue.prototype.sendImMessage = sendImMessage
Vue.prototype.timQuitGroup = timQuitGroup
Vue.prototype.timLogout = timLogout
Vue.prototype.TimLogOut = TimLogOut
Vue.prototype.$bus = new Vue()